<template>
    <div v-if="isAuthenticated()">
        <nav-bar></nav-bar>
        <v-main>
            <v-container :fluid="true">            
                <transition name="page" mode="out-in">
                    <keep-alive>
                        <router-view></router-view>
                    </keep-alive>
                </transition>                    
            </v-container>
        </v-main>
        <v-footer class="white--text" app absolute padless color="#323234">
            <v-col class="text-center" cols="12">
                {{ new Date().getFullYear() }} — <strong>OTC Cube</strong>
            </v-col>
        </v-footer>
    </div>
    <div v-else>
        <v-main>
            <login-box></login-box>
        </v-main>
    </div>
</template>

<script>

import NavBar from "@/components/NavBar"
import LoginBox from "@/components/LoginBox"
import { Utils } from "@/Utils"

export default {
    components:
    {
        NavBar,
        LoginBox
    },

    mixins: [Utils]    
};
</script>
<style>

.page-enter-active, .page-leave-active
{
    transition: opacity 0.5s, transform 0.5s;
}
.page-enter, .page-leave-to
{
    opacity: 0;
    transform: translateX(-30%);
}

div.container
{
    background: #474749 !important;
}

</style>